import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {captureException} from '@sentry/react'
import {
    httpGetMeasureDetails,
    HttpGetMeasureDetailsResponse
} from '@/features/measure-details/services/measureDetails.http.ts'

export const useGetMeasureDetails = (id?: string) => {
    return useQuery({
        queryKey: [QUERY_KEYS.MEASURE_DETAILS, id],
        queryFn: async () => {
            return await parseAxiosPromise({
                axiosPromise: httpGetMeasureDetails(id),
                responseShape: HttpGetMeasureDetailsResponse,
                onZodError: captureException
            })
        },
        enabled: !!id,
        retry: 0
    })
}
